import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, ElementRef, Renderer2 } from '@angular/core';

import { environment } from './../environments/environment';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import fontawesome from '@fortawesome/fontawesome';
import faSolidPack from '@fortawesome/fontawesome-free-solid';
import faRegularPack from '@fortawesome/fontawesome-free-regular';
import faBrandsPack from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(faSolidPack);
fontawesome.library.add(faRegularPack);
fontawesome.library.add(faBrandsPack);


import { DarkadiaRoutingModule } from './darkadia-routing.module';

import { GamesService } from './services/games.service';

import { DarkadiaComponent } from './darkadia.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { SigninComponent } from './components/signin/signin.component';
import { SignonComponent } from './components/signon/signon.component';
import { GameNavComponent } from './components/game-nav/game-nav.component';
import { GameLinkComponent } from './components/game-link/game-link.component';
import { NewsComponent } from './components/news/news.component';
import { ForumComponent } from './components/forum/forum.component';
import { BlogComponent } from './components/blog/blog.component';
import { ShopComponent } from './components/shop/shop.component';
import { AboutComponent } from './components/about/about.component';
import { JobComponent } from './components/job/job.component';
import { ContactComponent } from './components/contact/contact.component';
import { NewsCarouselComponent } from './components/news-carousel/news-carousel.component';


@NgModule({
  declarations: [
    DarkadiaComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    SigninComponent,
    SignonComponent,
    GameNavComponent,
    GameLinkComponent,
    NewsComponent,
    ForumComponent,
    BlogComponent,
    ShopComponent,
    AboutComponent,
    JobComponent,
    ContactComponent,
    NewsCarouselComponent,
  ],
  imports: [
    BrowserModule,
    DarkadiaRoutingModule,
    HttpClientModule, 
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    NgbModule.forRoot()
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    GamesService,
  ],
  bootstrap: [DarkadiaComponent]
})
export class DarkadiaModule { }



// WEBPACK FOOTER //
// ./src/app/darkadia.module.ts